"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.user = void 0;
const axios_class_1 = require("./axios.class");
class User {
    findOne(id) {
        return axios_class_1.axios.get(`/users/${id}`);
    }
    getCodeForDAN({ phone, language, email, recaptchaToken, whatsapp, marketplaceId }) {
        return axios_class_1.axios.post(`/v2/users/getCodeForDAN`, {
            phone,
            language,
            email,
            recaptchaToken,
            whatsapp,
            marketplaceId
        });
    }
    getAddressFromPhone(phone, code) {
        return axios_class_1.axios.post(`/users/getAddressFromPhone`, {
            phone,
            code
        });
    }
    getAddressFromAuthentication(code, phone, email) {
        return axios_class_1.axios.post(`/users/getAddressFromAuthentication`, {
            phone,
            email,
            code
        });
    }
    delete(id) {
        return axios_class_1.axios.delete(`/users/${id}`);
    }
    setEmail(email) {
        return axios_class_1.axios.post(`/users/setEmail`, { email });
    }
    confirmEmailWithToken(userId, emailConfirmationToken) {
        return axios_class_1.axios.post(`/users/confirmEmailWithToken`, { userId, emailConfirmationToken });
    }
    setSettings(settings) {
        return axios_class_1.axios.patch(`/users/settings`, settings);
    }
    addFCMToken(deviceUUID, token) {
        return axios_class_1.axios.post(`/users/fcmToken`, {
            deviceUUID,
            token
        });
    }
    removeFCMToken(deviceUUID) {
        return axios_class_1.axios.post('/users/fcmToken/delete', {
            deviceUUID
        });
    }
    async getBadges() {
        const { data } = await axios_class_1.axios.get('/users/badges');
        return data;
    }
    async setIcon(iconData) {
        const formData = new FormData();
        formData.append('image', iconData.image);
        formData.append('extension', iconData.extension);
        const { data } = await axios_class_1.axios.post('/users/setIcon', formData, {
            headers: {
                contentType: 'multipart/form-data'
            }
        });
        return data;
    }
    setAlias(alias) {
        return axios_class_1.axios.post('/users/setAlias', {
            alias
        });
    }
}
exports.user = new User();
